import SvgIcon from '../SvgIcon'

export const ConsentButton = ({ onClick, classnames, type }) => {
  return (
    <button
      className={classnames}
      onClick={onClick}
      data-testid="tcb-banner-button"
    >
      {type === 'info' ? 'Ok' : <SvgIcon name="closeDarkGray" />}
    </button>
  )
}
